import { render, staticRenderFns } from "./Stockholders.vue?vue&type=template&id=18070c3c&scoped=true"
import script from "./Stockholders.vue?vue&type=script&lang=js"
export * from "./Stockholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18070c3c",
  null
  
)

export default component.exports